import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const Button = ({
  children,
  onClick,
  isPrimary,
  isSecondary,
  isPrimaryBlock,
  isDisabled,
  disabled,
  ...props
}) => {
  const [isSubmitting, setSubmitting] = useState(false);
  const submittingRef = useRef(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const handleClick = (event) => {
    if (submittingRef.current) return;

    const result = onClick?.(event);
    if (!result || typeof result.then !== "function") return;

    submittingRef.current = true;
    setSubmitting(true);

    const finish = () => {
      submittingRef.current = false;
      if (mountedRef.current) setSubmitting(false);
    };
    result.then(finish, finish);
  };

  return (
    <button
      className={`btn ${isPrimary ? "btn-teal" : ""} ${
        isSecondary ? "btn-teal-outline mr-2" : ""
      } ${
        isPrimaryBlock ? "btn-block btn-sign-in mt-3 mt-sm-0" : ""
      } px-5 font-weight-bold`}
      onClick={handleClick}
      {...props}
      disabled={isDisabled || disabled || isSubmitting}
      aria-busy={isSubmitting || undefined}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isPrimary: PropTypes.bool,
  isSecondary: PropTypes.bool,
};

export default Button;
